// src/locale/isArabic.ts
var isArabic = (str) => {
  return str && /^[\u0621-\u064A\x20]+$/.test(str == null ? void 0 : str.trim());
};

export {
  isArabic
};
//# sourceMappingURL=chunk-I7RGYTHQ.mjs.map